import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'box-info-router-addess',
    templateUrl: './box-info-router-addess.component.html',
    styleUrls: ['./box-info-router-addess.component.css']
})
export class BoxInfoRouterAddessComponent implements OnInit {

  @Input() item: any;
  constructor() { }

  ngOnInit() {
  }

    public formatarCEP(cep: string) : string
    {
        if(cep == undefined || cep == null)
        {
            return '';
        }

        var resultado = cep.toString();

        if (cep.toString().length == 7)
        {
            resultado = "0" + cep.toString().substring(0, 4) + "-" + cep.toString().substring(4, 7);
        }
        else if (cep.toString().length == 8)
        {
            resultado = cep.toString().substring(0, 5) + "-" + cep.toString().substring(5, 8);
        }

        return resultado;
    } 

}